// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MeRm0","select":"styles_select__1-ifs"};